export const api = {
  v1: {
    tst: "https://jsonplaceholder.typicode.com/todos/1",
    ok: "http://httpstat.us/200",
    err300: "http://httpstat.us/300",
    err400: "http://httpstat.us/400",
    err500: "http://httpstat.us/500"
  }
};

export const firebaseConfig = {
    apiKey: "AIzaSyBIMZQC4XOKXUXpr42DFKeVzKwaQolI694",
    authDomain: "oopark.firebaseapp.com",
    databaseURL: "https://oopark.firebaseio.com",
    projectId: "oopark",
    storageBucket: "oopark.appspot.com",
    messagingSenderId: "742571059610",
    appId: "1:742571059610:web:d8784cfe086ee135183223"
};

export default {
  api,
  firebaseConfig
};
